@if (url()) {
  <svg-icon
    [src]="url()"
    svgClass="icon {{size()}} {{colour()}}"
  [svgAriaLabel]="alt()"></svg-icon>
}
